import { metadata } from './support'

export const getUploadUrl = async () => {
  const { data } = await metadata.getJson('conversion/transfer/upload-url', 2)
  return data
}
